<template>
  <nav-bar title="公司列表" />
  <Content :bottom="0" @content-scroll="handleContentScroll">
    <Loading v-if="showLoading" :isLoading="isLoading" @reload="getList" />
    <ul class="company-list">
      <li v-for="item in list" :key="item.id" class="company-list-item">
        <div class="company-list-item__title">{{ item.name }}</div>
        <van-row gutter="20">
          <van-col span="8">
            <van-button
              block
              type="danger"
              size="mini"
              icon="delete"
              @click="handleDelClick(item.id)"
              >删除</van-button
            >
          </van-col>
          <van-col span="8">
            <van-button
              block
              type="warning"
              size="mini"
              icon="edit"
              :to="`/modifyCompany/${item.id}`"
              >修改</van-button
            >
          </van-col>
          <van-col span="8">
            <van-button
              block
              type="primary"
              size="mini"
              icon="setting-o"
              :to="`/deployRegion/${item.id}`"
              >配置</van-button
            >
          </van-col>
        </van-row>
      </li>
    </ul>
    <loading-more
      :finished="finished"
      :showLoadingMore="showLoadingMore"
      :loadingFail="loadingFail"
      :list="list"
      @reload="reload()"
    />
  </Content>
</template>

<script>
import { Dialog, Toast, Notify } from 'vant'
import { companyList, delCompany } from '@/api/list'
import { useLoadingMore } from '@/hooks/useLoadingMore'
export default {
  name: 'CompanyList', // 公司列表
  setup() {
    const data = useLoadingMore(companyList)
    const { getList, list, finished, loadingFail, pageParams } = data

    // 初始化list
    list.value = []
    pageParams.page = 1
    pageParams.tenantId = localStorage.getItem('tenant_id') || ''
    finished.value = false
    loadingFail.value = false
    getList()

    // 删除公司
    const handleDelClick = (id) => {
      Dialog.confirm({
        title: '删除',
        message: '确定要永久删除该公司？'
      })
        .then(async () => {
          // on confirm
          try {
            const { status } = await delCompany(id)
            if (status === 200) {
              Notify({ type: 'success', message: '删除成功' })
              // 初始化list
              list.value = []
              pageParams.page = 1
              finished.value = false
              loadingFail.value = false
              getList()
            } else {
              // 初始化list
              list.value = []
              pageParams.page = 1
              finished.value = false
              loadingFail.value = false
              getList()
            }
            Toast.clear()
          } catch {
            Toast.clear()
          }
        })
        .catch(() => {
          // on cancel
        })
    }
    return {
      ...data,
      handleDelClick,
      getList
    }
  }
}
</script>

<style lang="scss" scoped>
.company-list {
  padding: 16px 16px 0 16px;
  .company-list-item {
    padding: 10px 16px;
    font-size: 16px;
    background-color: #fff;
    box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px,
      rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
    margin-bottom: 16px;
    color: #666;
    &__title {
      font-weight: 600;
      margin-bottom: 10px;
    }
  }
}
</style>
